import {useState} from "react";
import {useQueryClient} from "@tanstack/react-query";
import {t} from "../../../../store/localization/TranslMessasge";
import {CommonTranslationKey} from "../CommonTranslationKey";
import {ErrorTranslationKey} from "../ErrorTranslationKey";
import Snackbar from "../snackbar/Snackbar";
import DeleteConfirmationDialog from "../../../../components/dialogs/DeleteConfirmationDialog";
import userGroupApiClient from "../../../../common/apis/usergroup/UserGroupApiClient";
import {UserGroupsTranslationKey} from "./UserGroupsTranslationKey";
import {invalidateFindAllUserGroupsQueryCache} from "./UserGroupQuery";

export interface UserGroupDeleteDialogProps {
    open: boolean;
    groupId: string;
    onClose: () => void;
    onDeleted: () => void;
}

export default function UserGroupDeleteDialog(props: Readonly<UserGroupDeleteDialogProps>) {
    const {open, groupId, onClose, onDeleted} = props;

    const queryClient = useQueryClient();
    const [deleteInProgress, setDeleteInProgress] = useState<boolean>(false);

    function deleteUserGroup(groupId: string) {
        setDeleteInProgress(true);
        userGroupApiClient.delete(groupId)
            .then(() => {
                invalidateFindAllUserGroupsQueryCache(queryClient);
                onDeleted();
                onClose();
                Snackbar.success(t(CommonTranslationKey.DATA_DELETED_SUCCESSFULLY));
            })
            .catch((err) => {
                Snackbar.error(t(ErrorTranslationKey.UNEXPECTED_ERROR_OCCURRED), err);
            })
            .finally(() => setDeleteInProgress(false));
    }

    if (!groupId) {
        return null;
    }

    return (
        <DeleteConfirmationDialog
            open={open}
            title={t(UserGroupsTranslationKey.DELETE_USER_GROUP_QUESTION_MARK)}
            message={t(UserGroupsTranslationKey.USER_GROUP_WILL_BE_DELETED)}
            deleteDisabled={deleteInProgress}
            onDelete={() => deleteUserGroup(groupId)}
            onDismiss={onClose}/>
    );
}
